var GridMonitorInformationComponent = /** @class */ (function () {
    function GridMonitorInformationComponent() {
    }
    GridMonitorInformationComponent.prototype.agInit = function (params) {
        this.monitor = params.data;
    };
    return GridMonitorInformationComponent;
}());
export { GridMonitorInformationComponent };
